export default __webpack_public_path__ + "static/25-81e98cd5a78daaa0f34b5aaa09646716.jpg";